import * as React from "react";
import {createRoot} from "react-dom/client";
import App from "./components/App";
import {FluentProvider, webLightTheme} from "@fluentui/react-components";

const rootElement: HTMLElement | null = document.getElementById("container");
const root = rootElement ? createRoot(rootElement) : undefined;

function addMasterCategory() {
    try {
        const mailbox = Office.context?.mailbox as Office.Mailbox | undefined;
        if (!mailbox?.masterCategories?.addAsync) {
            return;
        }

        const categoryColor = Office.MailboxEnums?.CategoryColor?.Preset3;
        if (categoryColor === undefined) {
            return;
        }

        const masterCategoriesToAdd = [
            {
                displayName: "zLawyer",
                color: categoryColor,
            },
        ];

        mailbox.masterCategories.addAsync(masterCategoriesToAdd, (asyncResult) => {
            if (asyncResult.status === Office.AsyncResultStatus.Succeeded) {
                console.log("Successfully added categories to master list");
            } else {
                console.log("masterCategories.addAsync call failed with error: " + asyncResult.error.message);
            }
        });
    } catch (error) {
        console.warn("addMasterCategory skipped:", error);
    }
}

function renderApp() {
    root?.render(
        <React.StrictMode>
            <FluentProvider theme={webLightTheme}>
                <App />
            </FluentProvider>
        </React.StrictMode>
    );
}

Office.onReady(() => {
    addMasterCategory();
    renderApp();
});

if ((module as any).hot) {
    (module as any).hot.accept("./components/App", () => {
        const NextApp = require("./components/App").default;
        root?.render(NextApp);
    });
}
